import React from 'react'
import { UserForm } from '../component/admin/UserForm'
import { Navbar } from '../component/shared/Navbar'
import { Box } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { AdminMenu } from '../component/admin/AdminMenu'

export const CreateUserScreen = () => {
  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Admin</title>
      </Helmet>

      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <UserForm title={'Create New User'} />
      </Box>
    </>
  )
}
